import lottieWeb, { AnimationConfigWithData, AnimationItem } from 'lottie-web';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import LottieController, { createLottieController } from './LottieController';

type LottieProps = {
  // animationData is a string to ensure we don't run into this memory issue: https://github.com/airbnb/lottie-web/issues/2070
  animationData: string;
  className?: string;
  onLoad?: (lottieController: LottieController) => void;
  style?: CSSProperties;
} & Pick<AnimationConfigWithData, 'autoplay' | 'loop'>;

const Lottie = ({ animationData, className, onLoad, style, autoplay = false, loop = false }: LottieProps) => {
  const container = useRef<HTMLDivElement>(null);
  const [lottieAnimation, setLottieAnimation] = useState<AnimationItem>();

  useEffect(() => {
    if (container.current) {
      if (lottieAnimation) {
        // Use instance destroy instead of lottieWeb.destroy(), the global version
        // destroys every animation on the page, causing other Lottie instances to disappear.
        lottieAnimation.destroy();
      }
      const animation = lottieWeb.loadAnimation({
        container: container.current,
        animationData: JSON.parse(animationData),
        loop,
        autoplay
      });
      setLottieAnimation(animation);
      if (onLoad) {
        onLoad(createLottieController(animation));
      }
    }
  }, [animationData, container]);

  useEffect(
    () => () => {
      if (lottieAnimation) {
        lottieAnimation.destroy();
      }
    },
    [lottieAnimation]
  );

  return <div ref={container} className={className} style={style} />;
};

export default Lottie;
